import axios from './axios';

export default {
  getRevision: async (id, params) => {
    const body = { params };
    const { data } = await axios.get(`/documents/${id}/revision`, body);
    return data;
  },

  get: async params => {
    const body = { params };
    const { data } = await axios.get('/documents', body);
    return data;
  },

  getShortResponse: async params => {
    const body = { params };
    const { data } = await axios.get('/documents/browse-documents', body);
    return data;
  },

  getById: async id => {
    const { data } = await axios.get(`/documents/${id}`);
    return data;
  },

  create: async body => {
    const { data } = await axios.post(`/documents`, body);
    return data;
  },

  update: async (id, body) => {
    const { data } = await axios.put(`/documents/${id}`, body);
    return data;
  },

  updateCreativity: async (id, query) => {
    const params = { params: query };
    const { data } = await axios.put(
      `/documents/${id}/update-creativity`,
      null,
      params
    );
    return data;
  },

  updateStatus: async (id, query) => {
    const params = { params: query };
    const { data } = await axios.post(
      `/documents/${id}/change-status`,
      null,
      params
    );
    return data;
  },

  delete: async id => {
    const { data } = await axios.delete(`/documents/${id}`);
    return data;
  },

  getItineraryLinks: async (id, query) => {
    const params = { params: query };
    const res = await axios.get(`/documents/${id}/itineraries/linked`, params);
    return res;
  },

  documentApproval: async (id, query) => {
    const { status, cause } = query;
    const res = await axios.post(
      `/documents/${id}/document-approval`,
      { cause },
      {
        params: {
          status: status
        }
      }
    );
    return res;
  },

  getManagedDocuments: async params => {
    const body = { params };
    const { data } = await axios.get(
      '/documents/manage-documents/browse',
      body
    );
    return data;
  },

  updateFeatured: async body => {
    const { data } = await axios.put(
      `/documents/manage-documents/update-featured`,
      body
    );
    return data;
  },

  projectValues: async query => {
    const params = { params: query };
    const { data } = await axios.get(`/documents/projects/values`, params);
    return data;
  },

  kindValues: async query => {
    const params = { params: query };
    const { data } = await axios.get(`/documents/kind/values`, params);
    return data;
  }
};
